import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FiGrid,
  FiUsers,
  FiActivity,
  FiLogOut,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import logo from "../assets/images/expo-pilot-logo.png";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { CiCreditCard1 } from "react-icons/ci";
import { IoIosFiling } from "react-icons/io";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isCollapsed, setIsCollapsed] = useState(
    () => localStorage.getItem("sidebarCollapsed") === "true"
  );

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", isCollapsed);
  }, [isCollapsed]);

  const menuItems = [
    { label: "Dashboard", path: "/dashboard", icon: <FiGrid /> },
    { label: "Users", path: "/users", icon: <FiUsers /> },
    { label: "Monitoring", path: "/monitoring", icon: <FiActivity /> },
    { label: "Billing", path: "/billing", icon: <LiaFileInvoiceDollarSolid /> },
    { label: "Subscriptions", path: "/subscriptions", icon: <CiCreditCard1 /> },
    { label: "Demo Request", path: "/demo-request", icon: <IoIosFiling /> },
  ];

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <aside
      className={`h-screen transition-all duration-300 ${isCollapsed ? "w-20" : "w-64"
        } bg-white border-r border-slate-200`}
    >
      <div className="flex flex-col h-full">

        <div className="flex items-center justify-between px-4 py-5 border-b border-slate-200">
          <div className="flex items-center gap-3 overflow-hidden">
            <div className="w-10 h-10 rounded-xl border border-slate-200 flex items-center justify-center">
              <img src={logo} alt="Logo" className="w-6 h-6 object-contain" />
            </div>

            {!isCollapsed && (
              <div>
                <p className="text-xs uppercase tracking-wider text-slate-400">
                  Admin
                </p>
                <p className="text-sm font-semibold text-slate-800">
                  Super Console
                </p>
              </div>
            )}
          </div>

          <button
            onClick={() => setIsCollapsed((prev) => !prev)}
            className="w-8 h-8 rounded-lg border border-slate-200 flex items-center justify-center text-slate-500 hover:bg-slate-100 transition"
          >
            {isCollapsed ? <FiChevronRight /> : <FiChevronLeft />}
          </button>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {menuItems.map((item) => {
            const active =
              location.pathname === item.path ||
              (item.path !== "/dashboard" && location.pathname.startsWith(`${item.path}/`));

            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`w-full flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition ${active
                  ? "bg-slate-100 text-slate-900"
                  : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                  }`}
              >
                <span className="text-lg">{item.icon}</span>
                {!isCollapsed && <span>{item.label}</span>}
              </button>
            );
          })}
        </nav>

        <div className="px-3 py-4 border-t border-slate-200">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 justify-center rounded-xl px-4 py-3 text-sm font-medium text-slate-500 hover:bg-red-50 hover:text-red-600 transition"
          >
            <FiLogOut className="text-lg" />
            {!isCollapsed && <span>Logout</span>}
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;